<script lang="ts">
  import { APP_CODE, APP_VERSION } from "$lib/env"
  import { appStore } from "$lib/stores/app-store.svelte"
  import { deviceStore } from "$lib/stores/device-store.svelte"
  import LoaderCircleIcon from "@lucide/svelte/icons/loader-circle"

  const device = $derived(deviceStore.device)

</script>
<main class="relative h-full w-full flex items-center justify-center">
  <div class="absolute w-max top-4 inset-e-4 text-end font-mono text-xs font-light text-gray-800">
    <div>{APP_CODE}-{APP_VERSION}</div>
    <div>{device.device_id.toUpperCase().substring(0, 16)}</div>
  </div>
  <section class="relative w-max">
    <div class="relative w-28 text-center">
      <img src={undefined}
           class="hidden absolute size-28 -top-32"
           alt="">
      <LoaderCircleIcon class="size-8 inline-block animate-spin"/>
    </div>
  </section>
</main>